import React, { CSSProperties, useEffect } from 'react';
import { mergeRefs } from '../../common/utils';
import usePopper, { UsePopperOptions } from 'react-overlays/usePopper';
import { MenuBase } from '../Menu/MenuBase';
import { useTestId } from '../../hooks/useTestId/useTestId';

export interface IMenuItemPopperProps extends React.PropsWithChildren {
  triggerRef: React.RefObject<HTMLDivElement | HTMLButtonElement | null>;
  show: boolean;
  /**
   * @deprecated No longer required
   */
  zeroBorderRadius?: boolean;
  popperConfig?: UsePopperOptions;
}

export const MODIFIERS: UsePopperOptions['modifiers'] = [
  {
    name: 'offset',
    options: {
      offset: [0, 0]
    }
  },
  {
    name: 'preventOverflow',
    options: {
      padding: 0
    }
  }
];

export const MenuItemPopper = React.forwardRef<HTMLDivElement, IMenuItemPopperProps>(({ children, popperConfig, triggerRef, show, ...rest }, ref) => {
  const childRef = React.useRef<HTMLDivElement>(null);
  const mergedRef = mergeRefs([childRef, ref]);
  const { generateTestId } = useTestId(rest, 'MenuOnPopper');

  const popper = usePopper(triggerRef.current, childRef.current, {
    placement: 'right-start',
    modifiers: MODIFIERS,
    ...popperConfig
  });

  useEffect(() => {
    show && popper.update();
  }, [show]);

  return (
    <MenuBase ref={mergedRef} style={popper.styles.popper as CSSProperties} asDropdown {...generateTestId()} noWrap={true} show={show}>
      {show ? children : <></>}
    </MenuBase>
  );
});
